var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6897 11.3279C13.3574 10.3886 13.75 9.24016 13.75 8C13.75 4.82436 11.1756 2.25 8 2.25C4.82436 2.25 2.25 4.82436 2.25 8C2.25 9.24016 2.64261 10.3886 3.31033 11.3279C6.12713 9.37468 9.87287 9.37468 12.6897 11.3279ZM11.8513 12.2697C9.51967 10.7274 6.48032 10.7274 4.14871 12.2697C5.16812 13.1898 6.51864 13.75 8 13.75C9.48136 13.75 10.8319 13.1898 11.8513 12.2697ZM8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15ZM8.00004 7.70662C7.39279 7.70662 6.90051 7.21434 6.90051 6.60709C6.90051 5.99984 7.39279 5.50757 8.00004 5.50757C8.60729 5.50757 9.09956 5.99984 9.09956 6.60709C9.09956 7.21434 8.60729 7.70662 8.00004 7.70662ZM8.00004 8.95662C9.29764 8.95662 10.3496 7.9047 10.3496 6.60709C10.3496 5.30949 9.29764 4.25757 8.00004 4.25757C6.70243 4.25757 5.65051 5.30949 5.65051 6.60709C5.65051 7.9047 6.70243 8.95662 8.00004 8.95662Z",
    fill: "#070A26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.72e16b4fef52bca7b7a0b7fe56352a53.svg";
export { ForwardRef as ReactComponent };